import { formatPhoneNumber } from '../../../../../utils/formatPhoneNumber';

export const useVeterinarianInfos = (veterinarian) => {
  const { address, name } = veterinarian || {};
  const { postal_code, city, street, number, country } = address || {};

  const postalAddress =
    `${number || ''} ${street || ''} ${postal_code || ''} ${
      city || ''
    }`.trim() || '-';

  const veterinarianInfos = [
    {
      label: 'owners.show.veterinarian_groomer.name',
      content: name || '-',
      span: 1
    },
    {
      label: 'owners.show.veterinarian_groomer.postal_address',
      content: postalAddress,
      span: 2
    },
    {
      label: 'owners.show.veterinarian_groomer.country',
      content: country || '-',
      span: 1
    },
    {
      label: 'owners.show.veterinarian_groomer.phone_number',
      content: veterinarian?.phone_number?.number
        ? formatPhoneNumber(veterinarian.phone_number)
        : '-',
      span: 2
    },
    {
      label: 'owners.show.veterinarian_groomer.send_ads',
      content: veterinarian.send_ads || '-',
      span: 1
    }
  ];

  return { veterinarianInfos };
};
